(function() { module.exports = window["eventespresso"]["edtrServices"]; }());